import axios, { partnerServices } from "../../config/axios";
import {
  RESET_CPASSWORD,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_INVALID_REQUEST,
  CHANGE_PASSWORD_INVALID_STRENGTH,
  NETWORK_ERROR_CPASSWORD,
  LOADING_PASSWORD,
} from "../types";

const resetChangePassword = () => {
  return {
    type: RESET_CPASSWORD,
  };
};

const updatePassword = (userData, authTokenIs) => async (dispatch) => {
  dispatch(loading());

  await partnerServices
    .post("changePassword", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.responseCode) {
        case "0":
          dispatch(invalidStrength(res.data));
          break;

        case "1":
          dispatch(success(res.data));
          break;

        case "2":
          dispatch(failed(res.data));
          break;

        case "3":
          dispatch(invalid_request(res.data));

          break;

        default:
          dispatch(failed(res.data));
          break;
      }
    })
    .catch((err) => dispatch({ type: NETWORK_ERROR_CPASSWORD, payload: err }));
};

function loading() {
  return {
    type: LOADING_PASSWORD,
  };
}

function failed(data) {
  return {
    type: CHANGE_PASSWORD_FAILED,
    payload: data,
  };
}

function invalidStrength(data) {
  return {
    type: CHANGE_PASSWORD_INVALID_STRENGTH,
    payload: data,
  };
}

function invalid_request(data) {
  return {
    type: CHANGE_PASSWORD_INVALID_REQUEST,
    payload: data,
  };
}

function success(data) {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: data,
  };
}

export { resetChangePassword, updatePassword };
